module.exports = __webpack_public_path__ + "img/buckbeak_bowing.40bba1c6.jpg";